<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        อัปโหลดไฟล์
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลอินเทอร์เน็ตประจำที่
          </a>
        </li>
        <li class="active">อัปโหลดไฟล์  </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <h3 class="box-title">อัปโหลดไฟล์รายการส่งเสริมการขาย</h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-6">
                    <el-upload
                      type="file"
                      class="upload-demo"
                      ref="uploadInput"
                      action="#"
                      :on-change="previewFile"
                      :file-list="fileList"
                      :auto-upload="false"
                      :limit="1"
                      :on-remove="removeFile"
                    >
                    <el-button
                      slot="trigger"
                      size="small"
                      type="primary"
                    >เลือกไฟล์ PDF</el-button>
                    <el-button
                      style="margin-left: 10px;"
                      size="small"
                      type="success"
                      :disabled="upBtn"
                      @click="submitUpload"
                    >อัปโหลด</el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions,mapMutations} from "vuex"
export default {
  data(){
    return {
      formdata : null,
      filetype : null,
      upBtn: true,
      fileList: []
    }
  },
  created(){
    this.$store.dispatch('Manage_internet/get_provider_id')
    if(!this.monthly) this.$router.push({name : 'Operator_Manage_internet'})
  },
  computed : {
    ...mapState({
      store_form : store => store.Manage_internet.formdata,
      provider_id : store => store.Manage_internet.provider_id,
      admin_id : store => store.Manage_internet.user_id,
      monthly : store => store.Manage_internet.monthly
    })
  },
  methods: {
    ...mapMutations({
      STORE_FORM : "Manage_internet/STORE_FORM"
    }),
    ...mapActions({
      readFile : "Manage_internet/analyzeFile",
      readPdf : "Manage_internet/setObjPdf",
      prepareTable : "Manage_internet/prepareTable"
    }),
    previewFile(item){
      const file = item.raw
      this.formdata = new FormData()
      this.formdata.append('provider_id',this.provider_id)
      this.formdata.append('admin_id',this.admin_id)
      if(file.type === "application/pdf"){
        this.formdata.append('typeFile','pdf')
        this.formdata.append('created_promotion_from','pdf')
        this.formdata.append('monthly_regulate', this.monthly)
        this.formdata.append('file',file)
        this.upBtn = false
      }else{
        this.MessageBox("แจ้งเตือน","กรุณาอัปโหลดเฉพาะไฟล์ pdf","warning");
      }
    },
    removeFile(e){
      this.upBtn = true
    },
    submitUpload() {
      this.readFile(this.formdata)
      this.$router.push({name : 'Confirm_promotion_internet'})
    }
  }
};
</script>
